import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import VueI18nFilter from 'vue-i18n-filter'
// Vue.use(VueI18nFilter)
Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('../locale', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || localStorage.getItem('language') ? localStorage.getItem('language')  : 'ar',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || localStorage.getItem('language') ? localStorage.getItem('language')  : 'ar',
  messages: loadLocaleMessages()
})